import React from 'react'
import SelectBuffaloSabresTemplate from 'src/components/template/select/buffalo-sabres'
export default (props) => <SelectBuffaloSabresTemplate />
